import React, { lazy } from 'react'
import type { RouteObject } from 'react-router'

const Browse = lazy(() => import('./Browse'))

const routes: RouteObject[] = [
    {
        path: '/home',
        element: <Browse />
    }
]

export default routes
